function hideElement(element: Element) {
    element.classList.add('govuk-!-display-none');
}

function showElement(element: Element) {
    element.setAttribute('tabindex', "-1");
    element.classList.remove('govuk-!-display-none');
    element.removeAttribute("hidden");
}

function setupListeners(cookieBanner: Element) {
    const cookieBannerButtonAcceptHide = document.querySelector('.cookie-banner-accept--hide')!;
    const cookieBannerButtonRejectHide = document.querySelector('.cookie-banner-reject--hide')!;
    const cookieBannerButtonAccept = document.querySelector('.cookie-banner-button--accept')!;
    const cookieBannerButtonReject = document.querySelector('.cookie-banner-button--reject')!;
    const cookieBannerAccept = document.querySelector('.cookie-banner--accept')!;
    const cookieBannerReject = document.querySelector('.cookie-banner--reject')!;
    const cookieBannerMain = document.querySelector('.cookie-banner--main')!;

    function setCookie(type: string) {
        const date = new Date();
        const days = 365;
        date.setTime(date.getTime() + 24 * days * 60 * 60 * 1e3);
        document.cookie = 'mhclg_analytics=' + encodeURIComponent(type) + '; expires=' + date.toUTCString() + '; path=/';
    }

    function hideConfirmation(e: Event) {
        e.preventDefault();
        hideElement(cookieBanner);
    }

    function showConfirmation(e: Event) {
        const cookieValue = (e.target as HTMLInputElement).value;
        e.preventDefault();
        hideElement(cookieBannerMain);
        if (cookieValue === 'accept') {
            setCookie('accept');
            showElement(cookieBannerAccept);
        }
        if (cookieValue === 'reject') {
            setCookie('reject');
            showElement(cookieBannerReject);
        }
    }

    cookieBannerButtonAcceptHide.addEventListener('click', hideConfirmation);
    cookieBannerButtonRejectHide.addEventListener('click', hideConfirmation);

    cookieBannerButtonAccept.addEventListener('click', showConfirmation);
    cookieBannerButtonReject.addEventListener('click', showConfirmation);

}

function setupBanner() {
    const cookieBanner = document.querySelector('.govuk-cookie-banner');
    if (cookieBanner == null) return;

    if (document.cookie && document.cookie.indexOf('mhclg_analytics') !== -1) {
        hideElement(cookieBanner);
    } else {
        setupListeners(cookieBanner)
    }
}

document.addEventListener('DOMContentLoaded', () => setupBanner());
